import { render } from "./HeaderFragment.vue?vue&type=template&id=4a0df484"
import script from "./HeaderFragment.vue?vue&type=script&lang=js"
export * from "./HeaderFragment.vue?vue&type=script&lang=js"

import exportComponent from "/home/apriyadi/projects/investment-forecaster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__